import { render, staticRenderFns } from "./route-radio.vue?vue&type=template&id=052ab7b4&scoped=true"
import script from "./route-radio.vue?vue&type=script&setup=true&lang=js"
export * from "./route-radio.vue?vue&type=script&setup=true&lang=js"
import style0 from "./route-radio.vue?vue&type=style&index=0&id=052ab7b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ab7b4",
  null
  
)

export default component.exports